<section>

  <header>
    @if(currentViewState() === viewStates.Detail){
      <nav>
        <img src="/assets/img/mobile/blue-arrow-left.svg" alt="arrow left" width="8" height="17" />
        <span class="linkspan"  (click)="goBackToList()">Go to the domains list </span>
      </nav>
    }
    <section class="header">
      <h2>
        {{title()}} @if(currentViewState() === viewStates.List){
        <span>({{uniqueTedDomains().length ? uniqueTedDomains().length : 0}})</span>
      }
    </h2>
    <div class="controls">
      <img src="/assets/img/mobile/mb-arrow-{{expanded() ? 'down':'up'}}.svg" alt="arrow up" width="28" height="28" (click)="toggleBottomsheetHeight()" />

    </div>
  </section>
</header>

@if(mappedTedDomainData().length > 0 ){
  <div style="padding: 12px;">
    @if(currentViewState() === viewStates.List){ @for(ted of uniqueTedDomains(); track ted; let i = $index;){
      <div class="mb-domains-container" (click)="navigateToDetail(ted)">
        <div class="domains-color" [ngStyle]="{'background-color': ted.color}"></div>
        <div class="domain-parent">
          <div class="mb-domain-info">
            <div class="mb-domain-title">Domain {{ted.tedNumber}}</div>
            <img class="arrow-right-icon" alt="" src="/assets/img/mobile/arrow-right.svg" width="16" height="16">
          </div>
          <div class="mb-cath-link">
            <div class="mb-cath-link1">CATH :
              @if (ted.label === '-') {
                <span>No match</span>
              }
              @if (ted.label !== '-') {
                <span> {{ ted.label }} </span>
              }
            </div>
          </div>
          <div class="mb-domain-boundaries">Boundaries: {{getBoudariesSingle(ted.tedNumber)}}</div>
        </div>
      </div>
      }}

      @if(currentViewState() === viewStates.Detail){
        <div>
          <div class="content">
            <div class="text-parent">
              <div class="download-text">Source</div>
              <div class="ted-parent">
                <a class="ted ext" href="https://ted.cathdb.info/uniprot/{{accession()}}" target="_blank">TED</a>
              </div>
            </div>
            <div class="text-parent">
              <div class="download-text">CATH</div>
              <div class="link">
                @if (activeDomain().label === '-') {
                  <div class="desc">No match</div>
                }
                @if (activeDomain().label !== '-') {
                  <div class="desc">
                  <a class="mb-cath-link-desc" [href]="
                      'https://www.cathdb.info/version/v4_4_0/cathnode/' + activeDomain().label" target="_blank"  (click)="gaService.eventEmitter('CATH_clickthrough', 'domains', 'click', 'CATH_url', 'Clicks on CATH link from Domains info tooltip')"
                      >{{ activeDomain().label }}
                    </a>
                  </div>
                }
              </div>
            </div>
            <div class="text-parent">
              <div class="download-text">Quality</div>

              <article>{{ activeDomain()?.quality }}
                @if (activeDomain().quality === 'High-confidence') {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                    </svg>
                  </span>
                }
                @if (activeDomain().quality === 'Moderate') {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                    </svg>
                  </span>
                }
                @if (activeDomain().quality === 'Uncertain') {
                  <span>
                  </span>
                  }<br/>
                  <span ><span class="innertext">Qscore: {{ activeDomain()?.qscore }} </span></span><br/>
                  <span><span class="mb-innertext">Assignment: {{ activeDomain().cath_assignment_level === '-' ? 'No assignment' : activeDomain().cath_assignment_level }} </span> </span>
                </article>
              </div>
              <div class="text-parent">
                <div class="download-text">Boundaries</div>
                <div class="desc">{{getBoudariesSingle(activeDomain().tedNumber)}}</div>
              </div>
              <div class="text-parent">
                <div class="download-text">Length</div>
                <div class="desc">{{ activeDomain()?.length }}</div>
              </div>
              <div class="text-parent">
                <div class="download-text">Average pLDDT</div>
                <div class="high-wrapper">
                  <div class="high"> {{ activeDomain().plddt | number:'1.2-2' }}</div>
                </div>
              </div>
              <div class="mat-divider"></div>
            </div>

          </div>
        }
      </div>
    }
    @else{
    <div style="padding: 12px;">
      <div class="no-domain-parent">
        <div class="no-domain-information">No domain information available</div>
        <div class="infocontainer">
          <p class="mb-desctext">This protein does not currently have any TED data identified. Domain annotations will appear here if data becomes available in future updates.</p>
          <p class="mb-desctext">&nbsp;</p>
          <p class="mb-desctext">There are several reasons why an entry might not have any TED annotations, including the structural element does not qualify as a distinct domain according to TED's criteria, the fragment might not contain a complete domain or the overall entry has a very low pLDDT.</p>
        </div>
      </div>
    </div>
  }


</section>